export const asyncRetryParams = {
  retries: 3,
  factor: 2,
  minTimeout: 1000,
  maxTimeout: 30000,
};

export const POSTS_POLLING_INTERVAL = 10000;
export const POST_ATTACHMENTS_POLLING_INTERVAL = 20000;
